import { render, staticRenderFns } from "./CenterTabs.vue?vue&type=template&id=93c056b2&"
import script from "./CenterTabs.vue?vue&type=script&lang=ts&"
export * from "./CenterTabs.vue?vue&type=script&lang=ts&"
import style0 from "./CenterTabs.vue?vue&type=style&index=0&id=93c056b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports